import { Grid, TextField } from "@mui/material";
import React from "react";
import AppGridListItem from "../../components/appGridListItem/AppGridListItem";

const ApplicationDetails = ({ data }) => {
  return (
    <Grid container style={{ padding: "20px" }}>
      <Grid item xs={12}>
        <span className="modal-header">
          <b>Company Details</b>
        </span>
      </Grid>

      <>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem label="Company Name" value={data?.companyName} />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Incorporation Number"
            value={data?.incorporationNumber}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Contact Person Email"
            value={data?.contactEmail}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Contact Person Name"
            value={data?.contactPerson}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Contact Person Phone Number"
            value={data?.contactPhone}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Physical Address"
            value={data?.physicalAddress}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem label="Postal Address" value={data?.postalAddress} />
        </Grid>

        {data?.websiteLink && (
          <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
            <AppGridListItem label="Website" value={data?.websiteLink} />
          </Grid>
        )}
      </>

      <Grid container style={{ marginTop: "10px" }}>
        <span className="modal-header">
          <b>Shareholders</b>
        </span>
        <div style={{ padding: "0 5px", width: "100%" }}>
          <table className="summary-table">
            <thead>
              <th style={{ width: "15%" }}>Name</th>
              <th style={{ width: "15%" }}>Nationality</th>
              <th style={{ width: "15%" }}>Phone Number</th>
              <th style={{ width: "15%" }}>Email</th>
              <th style={{ width: "20%" }}>Occupation</th>
              <th>Shares</th>
            </thead>

            <tbody>
              {data?.shareholders?.map((item, index) => (
                <tr key={`item-${index}`}>
                  <td>{item?.name}</td>
                  <td>{item?.nationality}</td>
                  <td>{item?.phone}</td>
                  <td>{item?.email}</td>
                  <td>{item?.occupation}</td>
                  <td className="text-align-center">{`${item?.shares}%`}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Grid>

      <Grid container style={{ marginTop: "10px" }}>
        <span className="modal-header">
          <b>Directors</b>
        </span>
        <div style={{ padding: "0 5px", width: "100%" }}>
          <table className="summary-table">
            <thead>
              <th style={{ width: "15%" }}>Name</th>
              <th style={{ width: "15%" }}>Nationality</th>
              <th style={{ width: "15%" }}>Phone Number</th>
              <th style={{ width: "15%" }}>Email</th>
              <th style={{ width: "20%" }}>Designation</th>
              <th>Education</th>
            </thead>
            <tbody>
              {data?.directors?.map((item, index) => (
                <tr key={`item-${index}`}>
                  <td>{item?.name}</td>
                  <td>{item?.nationality}</td>
                  <td>{item?.phone}</td>
                  <td>{item?.email}</td>
                  <td>{item?.designation}</td>
                  <td>{item?.educationQualification}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Grid>

      <Grid container style={{ marginTop: "10px" }}>
        <Grid item xs={12}>
          <span className="modal-header">
            <b>Solution Summary</b>
          </span>
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem label="Solution Name" value={data?.solutionName} />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Nature of Operation"
            value={data?.natureOfOperation}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Scale of Operation"
            value={data?.scaleOfOperation}
          />
        </Grid>

        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Solution Attribute"
            value={data?.solutionAttribute}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Testing Period"
            value={`${data?.testingPeriod} months`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Deployment Duration"
            value={`${data?.deploymentDuration}`}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Source of Funds"
            value={data?.sourceOfFunds}
          />
        </Grid>
        <Grid item xs={12}></Grid>
        <Grid item xs={12} sm={6} md={4} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Solution Objectives"
            value={
              <TextField
                multiline
                fullWidth
                focused={false}
                value={data?.solutionObjectives
                  ?.toString()
                  .replaceAll(",", "\n")}
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Market of Operation"
            value={
              <TextField
                multiline
                fullWidth
                value={data?.marketOfOperation
                  ?.toString()
                  .replaceAll(",", "\n")}
                focused={false}
              />
            }
          />
        </Grid>

        <Grid item xs={12} sm={6} md={4} className="mt-10 padded-grid-item">
          <AppGridListItem
            label="Technologies Used"
            value={
              <TextField
                multiline
                fullWidth
                focused={false}
                value={data?.technologiesUsed?.toString().replaceAll(",", "\n")}
              />
            }
          />
        </Grid>

        <Grid item xs={12} style={{ marginTop: "10px" }}>
          <span className="modal-header">
            <b>Solution Details</b>
          </span>
        </Grid>
      </Grid>

      <Grid item xs={12} md={6} className="mt-10 padded-grid-item">
        <AppGridListItem
          label="Problem Description"
          value={data?.problemDescription}
        />
      </Grid>
      <Grid item xs={12} md={6} className="mt-10 padded-grid-item">
        <AppGridListItem
          label="Solution Description"
          value={data?.solutionDescription}
        />
      </Grid>
      <Grid item xs={12} md={6} className="mt-10 padded-grid-item">
        <AppGridListItem
          label="Legal Challenges"
          value={data?.legalChallenges}
        />
      </Grid>
      <Grid item xs={12} md={6} className="mt-10 padded-grid-item">
        <AppGridListItem
          label="Special Exemptions"
          value={data?.specialExemptions}
        />
      </Grid>

      <Grid item xs={12} style={{ marginTop: "10px" }}>
        <span className="modal-header">
          <b>Risks</b>
        </span>
      </Grid>

      <Grid container style={{ padding: "0 5px" }}>
        <table className="summary-table">
          <thead>
            <th style={{ width: "30%" }}>Name</th>
            <th>Measure</th>
          </thead>
          <tbody>
            {data?.risks?.map((risk) => (
              <tr>
                <td>{risk?.risk}</td>
                <td>{risk?.mitigationMeasure}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Grid>
    </Grid>
  );
};

export default ApplicationDetails;
